export default __webpack_public_path__ + "static/media/done.54ef579b.gif";